import { render } from 'preact';
import { getDevice } from './store/device';
import { ensurePersistentStorage } from './store/persistence';
import { Repo } from './store/repo';
import { App } from './ui/App';
import './ui/styles.css';

async function boot() {
  const root = document.getElementById('app')!;
  try {
    const repo = await Repo.open();
    const [device, storage, recovered] = await Promise.all([
      getDevice(repo),
      ensurePersistentStorage(repo),
      repo.recoverJournal(),
    ]);
    render(<App env={{ repo, device, storage, recovered }} />, root);
  } catch (e) {
    root.innerHTML = '';
    const p = document.createElement('pre');
    p.className = 'fatal';
    p.textContent = `Could not open the local database.\n\n${(e as Error).stack ?? e}`;
    root.append(p);
  }
}

void boot();
